module.exports = __webpack_public_path__ + "img/pr-1.55f3ef9d.png";